<template>
  <div class="file-upload" :class="{'default-cursor': imgSrc}" :style="`background-image: url(${imgSrc}) !important;`" @click="selectFile()">
      <div class="fade" v-if="imgSrc"></div>
      <input type="file" name="file" ref="file" @change="addFile($event)" @click="">
      <div class="title-container">
          <span class="title" v-if="!imgSrc">{{ documentName }}</span>
          <span class="edit" v-else>{{ documentName }}<br><span @click="editFile">Edit</span></span>
      </div>
  </div>
</template>

<script>
export default {
  name: "UploadFile",
  props: [
      'documentName'
  ],
  data() {
    return {
        imgSrc: ''
    };
  },
  methods: {
    selectFile(){
        if(this.imgSrc == '') this.$refs.file.click();
    },
    addFile(event) {
      let src = URL.createObjectURL(event.target.files[0]);
      this.imgSrc = src;
      this.$emit("change", event.target.files[0])
    },
    editFile() {
        if(this.imgSrc != '') {
            this.$refs.file.click();
            this.$emit("change", $refs.file.files[0]);
            this.$refs.file.files = [];
        }
    }
  },
};
</script>

<style scoped>
  /* <div class="file-upload">
      <input type="file" name="file">
      <div class="title-container">
          <span class="title"></span>
      </div>
  </div> */

  .file-upload {
      width: 260px;
      aspect-ratio: 26 / 20 !important;
      float: left;
      background: #FAE0E0;
      border-radius: 12px;
      cursor: pointer;
      color: #E10015;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      position: relative;
      overflow: hidden;
  }

  .file-upload input[type=file] {
      display: none;
  } 

  .fade {
      width: 100%;
      height: 100%;
      pointer-events: none;
      position: absolute;
      top: 0;
      left: 0;
      background: linear-gradient(0deg, rgba(34,38,41,0.8) 0%, rgba(34,38,41,0.6) 26%, rgba(34,38,41,0.05) 100%);
  }

  .title-container {
      position: absolute;
      bottom: 0;
      width:100%;
      height: auto;
      padding: 10px 16px;
  }

  .title-container .title {
      font-size: 16px !important;
      height: auto;
      word-break: break-word;
  }

    .title-container .edit {
      font-size: 16px !important;
      height: auto;
      word-break: break-word;
      color: white !important;
  }

  .title-container .edit span {
      color: #aaa;
      cursor: pointer;
  }
    
  .default-cursor {
      cursor: default !important;
  }

</style>